import React, {useState} from 'react'

export default function Home() {

    return(
        <div className='Home'>
            <img src="DC logo_nav.png" alt="game logo" width="400" height="200" ></img>
            <div className='gameDesc'>
                <h2> About </h2>
                Dimension Crawl is a rogue like game that demonstrates how PCG can be integrated into a video game. Explore 3
                different levels varying in difficulty and fight your way to the next level in order to escape the dimensional 
                rift. Run the game over and over again to explore endless possibilities and challenges. 

                <h2>Inspiration</h2>
                    <p>
                    As a group we wanted to showcase the power of PCG in content creation. 
                    This idea can help the entertainment industry specifically video games. 
                    Companies tend to put countless hours into producing new content tailored 
                    to an audience in their market. However, with PCG this step can be cut out 
                    when creating a game that’s purpose is to provide endless content to the 
                    consumer. We want to continue the process of testing and innovating PCG. 
                    </p>
                <h2>Framework and Diagrams</h2>
                    <figure>
                        <img src="490Diagram-1.png" alt="Framework" width={600} height={350} />
                        <figcaption>Game Engine Diagram</figcaption>
                    </figure>
                    <figure>
                        <img src="490-item.png" alt="Framework"/>
                        <figcaption>Item Generator Diagram</figcaption>
                    </figure>
                <h2>Major Features</h2>
                <p>You can view images of major features in the Gallery and Demo.</p>
                <ul>
                    <li><b>PCG made levels.</b></li>
                        <ul><li>Designed around creating unique level layouts. “room” - based approach, instead of generating all at once, we take it section by section. </li></ul>
                    <li><b>PCG made stats for weapons.</b></li>
                        <ul><li>Designed to create Items that are placed in random rooms and be of different rarity and type.</li></ul>
                    <li><b>PCG spawn locations for loot.</b></li>
                        <ul><li>After level generation, rooms are selected as item rooms. Items are are spawned from a pool of 4 possible types: Footgear, Armor, Rings, and Weapons.</li></ul>
                    <li><b>Dynamic music transitioning / for changing levels</b></li>
                        <ul><li>Randomizer selects music track to play at random. When song ends it doesn’t repeat.</li></ul>
                </ul>
            </div>
            <div id='TechAndSkills'>
                <div className='technologies'>
                <h1>Technologies</h1>
                    <ul>
                    <a href="https://unity.com/" target = "_blank"><li>Unity - Learn More</li></a>
                    <a href="https://docs.microsoft.com/en-us/dotnet/csharp/" target = "_blank"><li>C# - Learn More</li></a>
                    <a href="https://github.com/" target = "_blank"><li>Git - Learn More</li></a>
                    <a href="https://www.adobe.com/products/photoshop.html" target = "_blank"><li>Photoshop - Learn More</li></a>
                    <a href="https://code.visualstudio.com/" target = "_blank"><li>Visual Studio Code - Learn More</li></a>
                        </ul>
                </div>
                
                <div className='skills'>
                <h1>Skills</h1>
                    <ul>
                        <li>Game Development</li>
                        <li>Game Deseign</li>
                        <li>C#</li>
                        <li>Shaderlab</li>
                        <li>Unity</li>
                    </ul>
                </div>
            </div>
            <div className='git'>
            <a href="https://github.com/490-group/main-" target = "_blank"><h1>CLICK HERE TO VISIT OUR GIT</h1></a>
            </div>
        </div>

    )
}